export const currencyMoney = {
  locale: "es-CO",
  currency: "COP",
  formats: {
    number: {
      COP: {
        style: "currency",
        currency: "COP",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      },
    },
  },
}

export const currencyMoneyCents = {
  locale: "es-CO",
  currency: "COP",
  formats: {
    number: {
      COP: {
        style: "currency",
        currency: "COP",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      },
    },
  },
}

export const currencyIdentity = {
  locale: "es-CO",
  currency: "COP",
  formats: {
    number: {
      COP: {
        style: "decimal",
        currency: "COP",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      },
    },
  },
}

export const currencyPercent = {
  locale: "pt-BR",
  currency: "BRL",
  formats: {
    number: {
      BRL: {
        style: "decimal",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      },
    },
  }
}
